import { routes } from "router"
import { oldRoutes } from "router/old-routes"
import { BOOKING_MODES } from "pagesV2/pro/Bookings/constants"

// Top-level flag for every create / update of a booking made on the guide's own site, so the API
// checks the trip's Front-end Visibility (publish_on_guides_site) instead of the Marketplace toggle:
// `embedded` from the widget (and no mode, the old default), `guide_profile` from a Guide Profile.
// Sent on create and on every later update (add-ons, payment option); without it an update counts
// as a Marketplace booking and is rejected for a trip shown only on the guide's site.
export const getOwnSiteBookingParams = (mode) => {
  if (mode === BOOKING_MODES.embedded || !mode) return { embedded: true }
  if (mode === BOOKING_MODES.guideProfile) return { guide_profile: true }
  return {}
}

// Where the guest lands once a booking is paid, whatever paid it. The embed (and no mode, the old
// default) stays on the embedded confirmation so only the guest token is used; a logged-in client
// gets their own confirmation, and any other checkout the guest confirmation.
export const getBookingConfirmationPath = ({ mode, uuid, bookingUuid, accessToken, userRole }) => {
  if (mode === BOOKING_MODES.embedded || !mode) {
    return routes.embeddedExperienceBookingConfirmation({ uuid: uuid || bookingUuid, id: bookingUuid })
  }
  if (accessToken && userRole === "user") return routes.clientBookingConfirmation({ id: bookingUuid })
  return oldRoutes.bookingConfirmation({ id: bookingUuid })
}
